import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { authApi } from '../services/api';
import Header from '../components/Header';
import AdminWorkspace from '../admin/AdminWorkspace';

export default function ApplicationAdminPage() {
  const navigate = useNavigate();
  const [authorized, setAuthorized] = useState(false);
  const [error, setError] = useState('');
  useEffect(() => {
    let active = true;
    authApi
      .getCurrentUser()
      .then((response) => {
        if (!active) return;
        if (response.success && response.data?.superUser) setAuthorized(true);
        else navigate('/dashboard', { replace: true });
      })
      .catch(() => {
        if (active) setError('Unable to verify administration access. Reload to try again.');
      });
    return () => {
      active = false;
    };
  }, [navigate]);
  return (
    <div className="application-admin">
      <Header title="Administration" showMetrics={false} />
      {authorized ? (
        <AdminWorkspace />
      ) : (
        <main className="adviser-workspace-main">
          <p role={error ? 'alert' : 'status'}>{error || 'Verifying administration access…'}</p>
          {error && <Link to="/dashboard">Return to dashboard</Link>}
        </main>
      )}
    </div>
  );
}
